<template>
    <div>

        <rkm-area
            no-margin-top
            title="Filtro"
            type="fieldset"
        >
            <rkm-form ref="RkmForm">
                <rkm-row>

                    <rkm-col cols="2">
                        <rkm-form-date-picker
                            :max-date="additionals.dataAtual"
                            :validations="validations.data"
                            label="Data"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col class="4">
                        <rkm-form-select
                            :options="form.tiposAtendimento"
                            label="Tipo de atendimento"
                            show-default-option
                            text-field="text"
                            defaultOptionText="Todos"
                            v-model="model.tipoAtendimento"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            :validations="validations.unidade"
                            @change="handleUnidadeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                            :disabled="model.data ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                        :options="form.infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                        :disabled="model.unidadeId ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            defaultOptionText="Todos"
                            v-model="model.especialidadeId"
                            value-field="id"
                            :disabled="model.infraestruturaId ? false : true"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            label="Profissional"
                            @change="handleProfissionalChange"
                            show-default-option
                            text-field="nome"
                            defaultOptionText="Todos"
                            v-model="model.usuarioId"
                            value-field="id"
                            :disabled="model.infraestruturaId ? false : true"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="search"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clean"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-show="isSearch"
            no-margin-top
            title="Atribuir"
            type="fieldset"
        >
            <rkm-form ref="RkmFormAtribuir">

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="especialidadesJornada"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.especialidadeId"
                            value-field="id"
                            @change="handleUsuariosJornadaChange()"
                            :disabled="model.especialidadeId"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="usuariosJornada"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.usuarioId"
                            value-field="id"
                            :disabled="model.usuarioId"
                        />
                    </rkm-col>

                    <rkm-col cols=6>
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.procedimento"
                            :searchFields="fields.procedimento"
                            :text-field="p => `${formatProcedimento(p.codigo)} - ${p.nome}`"
                            label="Procedimento padrão"
                            v-rkm-tooltip.hover
                            v-model="atribuir.procedimento"
                            @input="handleProcedimento()"
                            :disabled="!atribuir.usuarioId"
                        >
                            <template v-slot:itemLabel="{ item }">
                                {{ formatProcedimento(item.codigo) }} - {{ item.nome }}
                            </template>

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="additionals.searchByApelido">
                                        <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                        <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalProcedimentos.open(atribuir)"
                                    color="primary"
                                    title="Adicionar procedimentos"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="atribuir.procedimento ? false : true"
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="atribuir.quantidade"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :requestQueryStringParams="autocompletesRequestParams.queryString.cid"
                            :searchFields="fields.cid"
                            :text-field="p => `${p.codigo} - ${p.nome}`"
                            label="CID padrão"
                            v-rkm-tooltip.hover
                            v-model="atribuir.cid"
                            :disabled="atribuir.procedimento ? false : true"
                            :validations="validations.cid"
                        >
                            <template v-slot:itemLabel="{ item }">
                                {{ formatCid(item.codigo) }} - {{ item.nome }}
                            </template>
                        </rkm-form-input-autocomplete>
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="additionals.locaisAtendimento"
                            label="Local de atendimento"
                            text-field="descricao"
                            v-model="atribuir.atencaoBasicaLocalAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="additionals.status"
                            label="Status padrão"
                            show-default-option
                            text-field="nome"
                            v-model="atribuir.statusId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="handleProcedimentoPadrao"
                            color="primary"
                            :disabled="handleDisabled()"
                        >
                            Atribuir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="cleanAtribuir"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <ModalProcedimentos
            ref="ModalProcedimentos"
            :filtro="{form, model}"
            :usuarios="usuariosJornada"
        />
    </div>
</template>

<script>
// Components.
import ModalProcedimentos from './components/atribuir/procedimentos/Modal'

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

//Enums
import localAtendimento from '@/enums/atencao-basica/marcador-consumo-alimentar/localAtendimento'
import agendamentoStatus from '@/enums/ambulatorio/agendamentoStatus'

export default {
    components: {
        ModalProcedimentos
    },
    computed: {
        validations() {
            return {
                data: {required: true},
                unidade: {required: true},
                infraestrutura: {required: true},
                quantidade: {
                    required: this.atribuir.procedimento ? true : false,
                    min_value: 1,
                    max_value: this.atribuir.procedimento && this.atribuir.procedimento.quantidadeMaximaExecucao
                        ? this.atribuir.procedimento.quantidadeMaximaExecucao : null
                },
                cid: { required: this.atribuir.procedimento && this.atribuir.procedimento.hasCidPrincipal ? true : false }
            }
        },
        fields() {

            return {
                procedimento: [
                    this.additionals.searchByApelido
                        ? { key: 'parametrizacao_procedimento.apelido', searchable: true }
                        : { key: 'nome', searchable: true }, { key: 'codigo', searchable: true }
                ],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        autocompletesRequestParams() {

            return {
                queryString: {
                    procedimento: {
                        search_by_apelido: this.additionals.searchByApelido || false,
                        ocupacao_id: this.atribuir.ocupacaoId,
                    },
                    cid: {
                        procedimento_id: this.atribuir.procedimento && this.atribuir.procedimento.hasCidPrincipal
                            ? this.atribuir.procedimento.id
                            : null
                    }
                },
            }
        },
    },
    created() {
        this.repositories = {
            fechamento: this.getConectaSusRepository('ambulatorio.fechamentoConsulta'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        others: {moment},
        atribuir: {
            procedimento: null,
            quantidade: null,
            cid: null,
            statusId: null,
            atencaoBasicaLocalAtendimentoId: null,
            procedimentos: [],
            usuarioId: null,
            ocupacaoId: null,
            especialidadeId: null,
        },
        isSearch: false,
        enums: {
            localAtendimento,
            agendamentoStatus
        },
        ocupacoesJornada: [],
        especialidadesJornada: [],
        usuariosJornada: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'infraestruturas',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                inicio: this.model.inicio,
                fim: this.model.fim,
                unidadeId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.$emit('cleaned', [])

            this.form.especialidades = []
            this.form.usuarios = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'especialidades',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.especialidades = response.data.especialidades

                    if (this.model.tipoAtendimento === 'demandaEspontanea' && response.data.especialidades.length === 0) {

                        this.handleEspecialidadeChange()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEspecialidadeChange(value) {
            this.$emit('cleaned', [])

            this.form.usuarios = []
            this.model.usuarioId = null
            this.isSearch = false

            if (value === null) return

            const request = {
                origem: 'busca',
                listar: 'usuarios',
                data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                especialidadeId: value,
                tipoAtendimento: this.model.tipoAtendimento,
            }

            this.setLoading()

            this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = response.data.usuarios
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuariosJornadaChange() {

            if (this.atribuir.especialidadeId) {

                const especialidade = this.especialidadesJornada
                        .find(especialidade => especialidade.id === this.atribuir.especialidadeId);

                const ocupacaoId = especialidade.ocupacao.id;

                this.atribuir.ocupacaoId = ocupacaoId

                const request = {
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    unidadeId: this.model.unidadeId,
                    infraestruturaId: this.model.infraestruturaId,
                    ocupacaoId: ocupacaoId,
                    especialidadeId: this.atribuir.especialidadeId,
                }

                this.setLoading()

                this.repositories.fechamento.getUsuariosWithJornada(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.usuariosJornada = response.data

                        if (this.model.usuarioId) {

                            const hasUsuario = response.data.find(item => item.id == this.model.usuarioId)

                            this.atribuir.usuarioId = hasUsuario ? this.model.usuarioId : null
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.usuariosJornada = []
            }
        },
        handleTipoAtendimentoChange() {

            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false
            this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS

            if (this.model.data) {

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    tipoAtendimento: this.model.tipoAtendimento,
                }

                this.setLoading()

                this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleProfissionalChange() {
            this.$emit('cleaned', [])
            this.isSearch = false
        },
        search() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                        unidadeId: this.model.unidadeId,
                        infraestruturaId: this.model.infraestruturaId,
                        especialidadeId: this.model.especialidadeId,
                        usuarioId: this.model.usuarioId,
                        tipoAtendimento: this.model.tipoAtendimento
                    }

                    this.setLoading()

                    this.repositories.fechamento.index(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.$emit('searched', response.data)
                            this.especialidadesJornada = response.data.especialidades
                            this.atribuir.especialidadeId = null
                            this.atribuir.usuarioId = null
                            this.cleanAtribuir()
                            this.usuariosJornada = []

                            const hasEspecialidade = this.especialidadesJornada.find(item => item.id == this.model.especialidadeId)

                            this.atribuir.especialidadeId = hasEspecialidade ? this.model.especialidadeId : null
                            this.handleUsuariosJornadaChange()
                            this.isSearch = true
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        handleProcedimentoPadrao() {

            this.$refs.RkmFormAtribuir.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.atribuir.procedimento) {

                        this.showConfirmation(
                            `O procedimento padrão será atribuído apenas às consultas selecionadas sem profissional
                            vinculado ou com o mesmo profissional selecionado em 'Atribuir'. Deseja continuar?`,
                            async () => this.handleAtribuir()
                        )
                    } else {

                        this.handleAtribuir()
                    }
                })
        },
        handleAtribuir() {

            this.$refs.RkmFormAtribuir.validate()
                .then(valid => {
                    if (valid === false) return

                    let msg = ''

                    this.consultas.filter(consulta => consulta.selecionado).map((item) => {

                        item.atencaoBasicaLocalAtendimentoId = this.atribuir.atencaoBasicaLocalAtendimentoId
                        item.statusId = this.atribuir.statusId

                        if (item.statusId === this.enums.agendamentoStatus.REALIZADO) {

                            const especialidade = this.especialidadesJornada
                                .find(especialidade => especialidade.id === this.atribuir.especialidadeId);

                            if (!item.usuarioNome && especialidade && this.handlePermissaoEspecialidade(item, especialidade)) {
                                item.usuarioId = this.atribuir.usuarioId
                                item.usuariosJornada = this.usuariosJornada
                                item.especialidadesJornada = this.especialidadesJornada
                                item.especialidadeId = this.atribuir.especialidadeId
                                item.ocupacaoId = especialidade.ocupacao.id;
                                item.criaFichaAtendimentoIndividual = especialidade.criaFichaAtendimentoIndividual
                                item.criaFichaAtendimentoOdontologico = especialidade.criaFichaAtendimentoOdontologico
                            }

                            if (item.usuarioId) {

                                if (item.usuarioId == this.atribuir.usuarioId && this.atribuir.procedimento && this.atribuir.procedimento.id) {

                                    const hasProcedimento = item.procedimentos.find(itemProcedimento => itemProcedimento.id === this.atribuir.procedimento.id
                                        && itemProcedimento.usuarioId === item.usuarioId
                                        && itemProcedimento.ocupacaoId=== item.ocupacaoId
                                    );

                                    if (!hasProcedimento) {

                                        item.procedimento = this.atribuir.procedimento
                                        item.quantidade = this.atribuir.quantidade
                                        item.cid = this.atribuir.cid
                                    } else {

                                        const usuario = this.usuariosJornada.find(usuario => usuario.id == item.usuarioId)

                                        msg = msg.concat(`O atendimento das <strong>(${item.horario} - ${item.cidadaoPacienteNome})</strong>
                                            já possui o procedimento <strong>(${this.atribuir.procedimento.codigo} - ${this.atribuir.procedimento.nome})</strong>
                                            para o usuário <strong>(${usuario.nome})</strong>
                                            vinculado. <br><br>`)
                                    }
                                }

                                this.atribuir.procedimentos.forEach(procedimento => {

                                    const existe = item.procedimentos.find(itemProcedimento => itemProcedimento.id === procedimento.id
                                        && itemProcedimento.usuarioId === procedimento.usuarioId
                                        && itemProcedimento.ocupacaoId === procedimento.ocupacaoId
                                    );

                                    if (!existe) {

                                        const hasPadrao = item.procedimento && item.procedimento.id === procedimento.id
                                            && item.usuarioId === procedimento.usuarioId
                                            && item.ocupacaoId === procedimento.ocupacaoId;

                                        if (!hasPadrao) {
                                            item.procedimentos.push(procedimento);
                                        } else {

                                            const usuario = this.usuariosJornada.find(usuario => usuario.id == item.usuarioId)

                                            msg = msg.concat(`O atendimento das <strong>(${item.horario} - ${item.cidadaoPacienteNome})</strong>
                                                já possui o procedimento <strong>(${procedimento.codigo} - ${procedimento.nome})</strong>
                                                para o usuário <strong>(${usuario.nome})</strong>
                                                vinculado. <br><br>`)
                                        }
                                    } else {

                                        const usuario = this.usuariosJornada.find(usuario => usuario.id == item.usuarioId)

                                        msg = msg.concat(`O atendimento das <strong>(${item.horario} - ${item.cidadaoPacienteNome})</strong>
                                            já possui o procedimento <strong>(${procedimento.codigo} - ${procedimento.nome})</strong>
                                            para o usuário <strong>(${usuario.nome})</strong>
                                            vinculado. <br><br>`)
                                    }
                                });
                            }
                        } else {
                            item.procedimento = null
                            item.cid = null
                            item.procedimentos = []
                        }
                    })

                    if(msg){

                        this.showAlert('A atribuição de um ou mais procedimentos não foi realizada para os seguintes atendimentos: <br><br>'  + msg, 'Atenção')
                    }
                })
        },
        handlePermissaoEspecialidade(item, especialidade) {

            if (especialidade.sexoId && especialidade.sexoId != item.cidadaoPacienteSexoId) {

                return false
            }

            if (especialidade.idadeMinima && item.cidadaoPacienteIdadeAnos < especialidade.idadeMinima) {

                return false
            }

            if (especialidade.idadeMaxima && item.cidadaoPacienteIdadeAnos > especialidade.idadeMaxima) {

                return false
            }

            return true
        },
        handleProcedimento() {
            if (this.atribuir.procedimento && this.atribuir.procedimento.id) {

                const index = this.atribuir.procedimentos.findIndex(procedimento => procedimento.id === this.atribuir.procedimento.id)

                if (index !== -1) {

                    this.showAlert('O procedimento já está incluído na lista de procedimentos a serem atribuídos.', "Atenção")
                    this.atribuir.procedimento = null
                }

                this.atribuir.quantidade = 1
                this.atribuir.cid = null
            } else {

                this.atribuir.quantidade = null
                this.atribuir.cid = null
            }
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false

            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.form.status = []

            if (this.model.data == this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')
                && this.model.tipoAtendimento == null) {

                this.handleTipoAtendimentoChange()
            }

            this.model.data = this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD')
            this.model.tipoAtendimento = null

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.atribuir.procedimento = null
            this.atribuir.procedimentos = []
            this.isSearch = false

            this.$refs.RkmForm.resetValidator()
        },
        cleanAtribuir() {
            this.atribuir.procedimento = null
            this.atribuir.procedimentos = []
            this.atribuir.quantidade = null
            this.atribuir.cid = null
            this.atribuir.statusId = null

            if (this.model.especialidadeId) {

                const hasEspecialidade = this.especialidadesJornada.find(item => item.id == this.model.especialidadeId)

                this.atribuir.especialidadeId = hasEspecialidade ? this.model.especialidadeId : null
            } else {

                this.atribuir.especialidadeId = null
            }

            if (this.model.usuarioId) {

                const hasUsuario = this.usuariosJornada.find(item => item.id == this.model.usuarioId)

                this.atribuir.usuarioId = hasUsuario ? this.model.usuarioId : null
            } else {

                this.atribuir.usuarioId = null
            }

            this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS
            this.atribuir.procedimentos = []
            this.usuariosJornada = []

            this.$refs.RkmFormAtribuir.resetValidator()
        },
        handleDisabled() {
            return this.consultas.filter(consulta => consulta.selecionado).length === 0 ? true : false
        }
    },
    mixins: [error, formats, repository, stringCase],
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
        consultas: {type: Array, required: true},
    },
    mounted() {

        const request = {
            origem: 'busca',
            listar: 'unidades',
            data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
            tipoAtendimento: this.model.tipoAtendimento,
        }

        this.setLoading()

        this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
            .then(response => {
                this.form.unidades = Object.assign(response.data.unidades)
                this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
    },
    watch: {
        'model.data'() {

            this.$emit('cleaned', [])

            this.additionals.searchByApelido = false
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.isSearch = false
            this.atribuir.atencaoBasicaLocalAtendimentoId = this.enums.localAtendimento.UBS
            this.atribuir.especialidadeId = null

            if (this.model.data) {

                const request = {
                    origem: 'busca',
                    listar: 'unidades',
                    data: this.others.moment(this.model.data).format('YYYY-MM-DD'),
                    tipoAtendimento: this.model.tipoAtendimento,
                }

                this.setLoading()

                this.repositories.fechamento.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        'model.tipoAtendimento'() {

            this.handleTipoAtendimentoChange()
        },
        'atribuir.especialidadeId'() {

            this.atribuir.usuarioId = null
            this.handleUsuariosJornadaChange()
        },
        'atribuir.usuarioId'() {

            this.atribuir.procedimento = null
            this.atribuir.quantidade = null
            this.atribuir.cid = null
        },
    },
}
</script>